
import React, { Component } from 'react';
import PropTypes from "prop-types";
import {IMAGE_HOST_URL} from "../../constants/ConfigFromBuildEnvironment";

export default class ImageCarouselView extends Component {

    static propTypes = {
        imageNames: PropTypes.arrayOf(PropTypes.string).isRequired,
        id: PropTypes.number.isRequired,
        imageClassName: PropTypes.string,
        viewHeightSize: PropTypes.number.isRequired,
    };

    static defaultProps = {
        viewHeightSize: 40,
    };

    render() {
        if(this.props.imageNames.length === 0) {
            return this.renderPlaceHolder();
        }
        return (
            <div id={"viewerCarousel_" + this.props.id} className="viewerCarousel carousel slide carousel-fade w-100" data-interval="false">
                <div className="carousel-inner">
                    {this.props.imageNames.map((image, index) => this.renderCarouselItem(image, index))}
                </div>
                {this.renderNavButtons()}
            </div>
        );
    }

    renderNavButtons() {
        if (this.props.imageNames.length <= 1) {
            return null;
        }
        return (
            <span>
                <a className="carousel-control-prev" href={"#viewerCarousel_"  + this.props.id} role="button" data-slide="prev">
                    <span><i className="fa fa-angle-left fa-2x" aria-hidden="true"/></span>
                    <span className="sr-only">Previous</span>
                </a>
                <a className="carousel-control-next" href={"#viewerCarousel_"  + this.props.id} role="button" data-slide="next">
                    <span><i className="fa fa-angle-right fa-2x" aria-hidden="true"/></span>
                    <span className="sr-only">Next</span>
                </a>
            </span>
        );
    }

    renderCarouselItem(image, index) {
        return (
            <div className={(index === 0) ? "carousel-item active": "carousel-item"} key={"carousel-image-"+index} style={{height: this.props.viewHeightSize + "vh"}}>
                <img className={"d-block w-100 min-vh-25 card-img-top " + this.props.imageClassName} data-interval="false" data-wrap="false" src={IMAGE_HOST_URL + image} alt="slide"/>
            </div>
        )
    }

    renderPlaceHolder() {
        return (
            <div id={"carouselExampleIndicators_" + this.props.spaceId} className="carousel">
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img className={"d-block w-100 card-img-top " + this.props.imageClassName} data-interval="false" data-wrap="false" src="https://via.placeholder.com/300x300.png?text=Preview" alt="slide"/>
                    </div>
                </div>
            </div>);
    }
}

